import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const ACCENT_BLUE = '#22638f';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const cardShell = {
  borderRadius: '16px',
  boxShadow: '0 2px 10px rgba(12, 61, 110, 0.05)',
  border: `1px solid ${BORDER}`,
};

const headerCellSx = {
  backgroundColor: '#fafcff',
  borderBottom: `1px solid ${BORDER}`,
  fontSize: '11.5px',
  fontWeight: 700,
  color: TEXT_MUTED,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  py: 1.5,
};

const bodyCellSx = {
  borderBottom: 'none',
  fontSize: '13px',
  color: TEXT_BODY,
  py: 1.2,
};

function RiceBasedkernalLength({ riceBasedkernalLength, beautify }) {

  const isMatrix =
    riceBasedkernalLength?.matrix &&
    Array.isArray(riceBasedkernalLength.matrix.rows) &&
    riceBasedkernalLength.matrix.rows.length > 0 &&
    Array.isArray(riceBasedkernalLength.matrix.columns) &&
    riceBasedkernalLength.matrix.columns.length > 0 &&
    Array.isArray(riceBasedkernalLength.matrix.data) &&
    riceBasedkernalLength.matrix.data.length > 0;

  return (
    <Box mt={3}>
      <TableContainer
        className="w-50 rs-width-100"
        sx={{ ...cardShell, backgroundColor: '#fff', overflow: 'hidden' }}
      >
        <Table size="medium">
          <TableHead>
            <TableRow>
              {isMatrix ? (
                <>
                  <TableCell sx={headerCellSx}>Width \ Height</TableCell>
                  {riceBasedkernalLength.matrix.columns.map((heightLabel, idx) => (
                    <TableCell key={idx} align="center" sx={headerCellSx}>
                      {heightLabel}
                    </TableCell>
                  ))}
                </>
              ) : (
                <>
                  <TableCell align="left" sx={headerCellSx}>Distribution Range</TableCell>
                  <TableCell align="left" sx={headerCellSx}>Count</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {isMatrix ? (
              riceBasedkernalLength.matrix.rows.map((widthLabel, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  sx={{
                    backgroundColor: rowIndex % 2 === 0 ? '#f8fbfe' : '#ffffff',
                    '&:hover': { backgroundColor: '#eef4fb' },
                  }}
                >
                  <TableCell component="th" scope="row" sx={{ ...bodyCellSx, fontWeight: 700, color: ACCENT_BLUE }}>
                    {widthLabel}
                  </TableCell>
                  {riceBasedkernalLength.matrix.data[rowIndex].map((value, colIndex) => (
                    <TableCell key={colIndex} align="center" sx={bodyCellSx}>
                      {value}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              Object.keys(riceBasedkernalLength.distributions || {}).map((key, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#f8fbfe' : '#ffffff',
                    '&:hover': { backgroundColor: '#eef4fb' },
                  }}
                >
                  <TableCell align="left" sx={{ ...bodyCellSx, fontWeight: 600 }}>
                    {(beautify && beautify[key]) || key}
                  </TableCell>
                  <TableCell align="left" sx={{ ...bodyCellSx, fontWeight: 700, color: ACCENT_BLUE }}>
                    {riceBasedkernalLength.distributions[key]}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default RiceBasedkernalLength;